import Image from 'next/image'

interface PropsLogo {
  src: string
}

export const Logo = ({ src }: PropsLogo) => {
  return (
    <div>
      <Image
        width={300}
        height={200}
        quality={75}
        priority={true}
        src={src}
        alt={'Logo Sur Neumaticos'}
        className={'mb-[12px] w-[180px] h-auto mt-4'}
      />
    </div>
  )
}
